/* eslint-disable react/prop-types */

'use strict';

const { h, Component } = require('preact');

const DiscountBadge = require('./discount_badge');
const PriceLabel = require('./label');
const MSRPLabel = require('./msrp_label');
const Value = require('./value');
const Price = require('./price');
const DoublestrikeRegularPrice = require('./doublestrike_regular_price');
const UrgencyPricingLabel = require('./urgency_price_label');

class OptionPricing extends Component {
  shouldShowPriceInSecondRow() {
    /*
      we should only push the price the second row if its:
        - a touch inline variations deal
        - desktop variations deal, with an option selected
          that has msrp label or urgency pricing
    */
    const {
      isGliveTouchSection,
      isTraitsSummary,
      option: {
        pricing: { msrpLabel },
        showDoubleStrikeThroughPrice,
      },
      touchRequest,
    } = this.props;
    return (
      (touchRequest && (isTraitsSummary || isGliveTouchSection)) ||
      (!touchRequest &&
        isTraitsSummary &&
        (msrpLabel || showDoubleStrikeThroughPrice))
    );
  }

  shouldShowPriceInFirstRow() {
    return !this.shouldShowPriceInSecondRow();
  }

  getPrice() {
    const {
      option: { enabled, isModalOption, showDoubleStrikeThroughPrice },
      isTraitsSummary,
      isMovieDeal,
    } = this.props;

    if (!enabled) {
      return null;
    }

    const showUrgencyPriceLabel =
      !isTraitsSummary && (showDoubleStrikeThroughPrice || isModalOption);

    let classes = '';

    if (isMovieDeal) classes += ' movie-ticket-option-price';

    return h(
      'div',
      {
        class: 'price-discount-wrapper',
      },
      showUrgencyPriceLabel ? h(UrgencyPricingLabel, this.props) : null,
      h(Price, {
        ...this.props,
        classes,
      })
    );
  }

  getValue() {
    const {
      isPaidCloDeal,
      option,
      showXForYStrikethrough,
      isXForYCloDeal,
    } = this.props;
    let classes = 'breakout-option-value';
    if (isPaidCloDeal) {
      classes += ' paid-clo-formatted-value';
    }

    return h(
      'div',
      {
        class: 'value-source-wrapper',
      },
      h(MSRPLabel, this.props.msrp),
      h(Value, {
        ...option,
        showXForYStrikethrough,
        isXForYCloDeal,
        classes,
      })
    );
  }

  getValueAndPrice() {
    const {
      option: {
        pricing: { msrpLabel },
        showDoubleStrikeThroughPrice,
      },
    } = this.props;

    let valueAndPriceClasses = 'pricing-options-wrapper';

    if (showDoubleStrikeThroughPrice) {
      valueAndPriceClasses += ' double-strike';
    }

    if (msrpLabel) {
      valueAndPriceClasses += ' with-msrp';
    }

    const showPrice = this.shouldShowPriceInFirstRow();

    return h(
      'div',
      {
        class: valueAndPriceClasses,
      },
      this.getValue(),
      h(DoublestrikeRegularPrice, this.props),
      showPrice && this.getPrice()
    );
  }

  getDiscount() {
    const { isMovieDeal } = this.props;

    const showPrice = this.shouldShowPriceInSecondRow();

    let classes = 'price-discount-message-wrapper';

    if (isMovieDeal) {
      classes += ' movie-discount-message-wrapper';
    }

    return h(
      'div',
      {
        class: classes,
      },
      showPrice && this.getPrice(),
      h(DiscountBadge, this.props)
    );
  }

  getExpiredOverlay() {
    const { enabled } = this.props.option;

    if (enabled) {
      return null;
    }

    return h('div', {
      class: 'status-overlay',
    });
  }

  getExpiredOverlayText() {
    const { enabled, text, optionStatus } = this.props.option;
    let classes = 'status-text';

    if (enabled) {
      return null;
    }

    if (optionStatus === 'sold_out') {
      classes = `${classes} sold-out-color`;
    }

    return h(
      'div',
      {
        class: classes,
      },
      `${text}`
    );
  }

  render() {
    const {
      isMovieDeal,
      isTraitsSummary,
      memberOnly,
      option: {
        enabled,
        isUrgencyPricing,
        priceDrop,
        pricing: { showIlsTimeLeft },
      },
    } = this.props;
    let mainClasses = 'breakout-pricing';

    if (!enabled) {
      mainClasses += ' sold-out';
    }

    if (priceDrop) {
      mainClasses += ' price-drop-pricing';
    }

    if (isMovieDeal) {
      mainClasses += ' movie-breakout-pricing';
    }

    if (isTraitsSummary) {
      mainClasses += ' has-traits';
    }

    if (showIlsTimeLeft) {
      mainClasses += ' with-price-label';
    }

    if (isUrgencyPricing) {
      mainClasses += ' urgency-pricing-offer';
    }

    if (memberOnly) {
      return h(
        'div',
        {
          class: mainClasses,
        },
        h(
          'div',
          {
            class: 'member-only',
          },
          memberOnly.title
        )
      );
    } else {
      return h(
        'div',
        {
          class: mainClasses,
        },
        !isMovieDeal && h(PriceLabel, this.props),
        !isMovieDeal && this.getValueAndPrice(),
        this.getDiscount(),
        this.getExpiredOverlay(),
        this.getExpiredOverlayText()
      );
    }
  }
}

module.exports = OptionPricing;
